import { useSiteConfig } from "../lib/site";

export default function Pricing() {
  const config = useSiteConfig();
  const p = config.pricing;

  return (
    <div className="space-y-4" data-testid="pricing-list">
      <div
        data-testid="price-session"
        className="flex flex-col gap-2 rounded-2xl border border-accent/50 bg-card p-6 shadow-[0_8px_30px_rgba(66,82,68,0.08)] sm:flex-row sm:items-baseline sm:justify-between sm:gap-8"
      >
        <div>
          <h3 className="font-serif text-2xl font-semibold text-primary">{p.session.label}</h3>
          <p className="mt-1 text-base text-muted-foreground">
            {p.session.minutes} minutes · {p.session.note}
          </p>
        </div>
        <p className="font-serif text-4xl font-semibold text-accent sm:text-right">${p.session.price}</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {p.packages.map((pkg) => (
          <div
            key={pkg.sessions}
            data-testid={`price-package-${pkg.sessions}`}
            className="rounded-2xl border border-dashed border-accent/60 bg-secondary/50 p-6"
          >
            <h3 className="font-serif text-2xl font-semibold text-primary">{pkg.sessions}-visit package</h3>
            <p className="mt-1 text-base text-muted-foreground">{pkg.note}</p>
            <p className="mt-3 font-serif text-3xl font-semibold text-accent">${pkg.total}</p>
          </div>
        ))}
      </div>

      <p className="pt-2 text-sm text-muted-foreground">{p.packages_note}</p>
    </div>
  );
}
